import { GET_DRIVER } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_DRIVER:
            return action.payload;
        default:
            return state;
    }
}